import * as React from 'react'
import { useSelector } from 'react-redux'
import { Grid, IconButton, Tooltip, Typography } from '@material-ui/core'
import SettingsIcon from '@material-ui/icons/Settings'
import SearchIcon from '@material-ui/icons/Search'

import {
  closeSearchBarToggle,
  closeSheet,
  openSearchBarToggle,
  resetMap,
} from '../../../features/maps/sections/Map/redux/myMapsSlice'

import CampusDropDown from '../../../features/maps/sections/Map/components/CampusDropDown/CampusDropDown'
import VehicleStopArrivalListDropDown from '../../../features/maps/sections/Vehicles/components/VehicleStopArrivalListDropDown/VehicleStopArrivalListDropDown'
import { ROUTE, VEHICLE } from '../../../features/maps/utils/constants'
import {
  LogOutButton,
  MyAlertsAndNotifications,
  VisitorModeLabel,
} from './DashboardLocalButtons'

export default function MapsLocalButtons({
  classes,
  isMobile,
  history,
  dispatch,
  userProfile,
  activeAlerts,
  dialogOpen,
  activeNotificationList,
}) {
  console.log('activeNotificationList maps module ', activeNotificationList)
  const isGuest =
    localStorage.getItem('user') === '"visitor"' ||
    localStorage.getItem('user') === ''
  const { bottomSheet, showSearchBar } = useSelector((state) => state.maps)

  const bottomSheetOpen = [ROUTE, VEHICLE].includes(bottomSheet.component)

  const handleSearchBarButtonClick = () => {
    if (showSearchBar) {
      dispatch(closeSearchBarToggle())
      dispatch(resetMap())
      dispatch(closeSheet())
    } else {
      dispatch(openSearchBarToggle())
    }
  }

  return (
    <Grid item md={4}>
      <Grid container justifyContent="flex-end" alignItems="center">
        {!isMobile ? (
          <Grid item style={{ marginRight: 4 }}>
            <VisitorModeLabel classes={classes} />
          </Grid>
        ) : null}

        <Grid item style={{ marginRight: 4 }}>
          <VehicleStopArrivalListDropDown
            isMobile={isMobile}
            dispatch={dispatch}
          />
        </Grid>

        {isMobile && bottomSheetOpen ? null : (
          <>
            <Grid item>
              <CampusDropDown />
            </Grid>
            <Grid item>
              <Tooltip
                title={<Typography variant="subtitle2">Search Menu</Typography>}
                placement="top"
                arrow
              >
                <IconButton
                  edge="start"
                  color="inherit"
                  aria-label="Search Menu"
                  onClick={handleSearchBarButtonClick}
                >
                  <SearchIcon className={classes.appBarIcon} />
                </IconButton>
              </Tooltip>
            </Grid>
          </>
        )}
        <MyAlertsAndNotifications
          dispatch={dispatch}
          isMobile={isMobile}
          isGuest={isGuest}
          classes={classes}
          activeAlerts={activeAlerts}
          activeNotificationList={activeNotificationList?.length}
          dialogOpen={dialogOpen}
        />
        {isMobile && !bottomSheetOpen && (
          <Grid item>
            <IconButton
              edge="start"
              color="inherit"
              aria-label="Search Menu"
              onClick={() => history.push('/settings')}
            >
              <SettingsIcon className={classes.appBarIcon} />
            </IconButton>
          </Grid>
        )}
        <LogOutButton
          isMobile={isMobile}
          dispatch={dispatch}
          userProfile={userProfile}
          classes={classes}
          history={history}
        />
      </Grid>
    </Grid>
  )
}
